module.exports = __webpack_public_path__ + "static/media/Team 26 Smart Sydney 8D005FBE-EAB5-4E49-A309-4E775B445D82 - Pavyashneha Muralitharan.26d330e9.jpeg";